// extracted by mini-css-extract-plugin
export var link = "_r6-0";